import { ModalBody, ModalFooter } from "@nextui-org/react";
import AllariaMasHeader from "../AllariaMasModal/AllariaMasHeader";
import Button from "../../../Button/Button";
import { closeModal } from "../../../../store/slices/unifiedBalanceSlice";
import { openModal as openDepositModal } from "../../../../store/slices/depositSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import styles from "./AllariaMasOnboardingModal.module.scss";
import unifiedIllustration from "../../../../assets/images/illustrations/unified-image.svg";
import { genericErrorMessage, isDev } from "../../../../utils";
import { addMessage } from "../../../../utils/addMessage";
import { openExternal } from "../../../NavBar/utils/utils";
import useScreenSize from "../../../../hooks/useScreenSize";
import { useEffect } from "react";

const AllariaMasOnboardingModal = () => {
  const dispatch = useAppDispatch();

  const {
    unifiedBalance: {
      selectedAccount: { name, number },
      assessmentData: { mainHolders, allaria_account },
      returnToDepositModal,
    },
    authentication: { user },
  } = useAppSelector((state) => state);

  const { bodyContainer, modalFooterMobile, cerrarBtn, unificarBtn } = styles;
  const { isMobile } = useScreenSize();

  useEffect(() => {
    if (!isMobile) return;
    const closeBtn = document.querySelector(
      '[aria-label="Close"]',
    ) as HTMLElement | null;
    if (!closeBtn) return;
    closeBtn.style.visibility = "hidden";
  }, [isMobile]);

  const nameParsed = name.split("-")[0].trim();

  const handleRedirect = async () => {
    try {
      if (!user?.email) return;

      //PersonType
      const personType = allaria_account.juridical
        ? "/empresarial"
        : "/personal";

      //Redirect to Allaria+ onboarding
      const baseURL = isDev
        ? `https://apertura-cuenta.allariamas.dev${personType}`
        : `https://apertura-cuenta.allariamas.com.ar${personType}`;

      const url = `${baseURL}?accountId=${number}&accountName=${nameParsed}&accountCuit=${mainHolders[0].fiscal_id}&accountEmail=${user?.email}`;
      openExternal(url, "_blank");
    } catch {
      addMessage({
        messageId: "allariaMasModal",
        message: genericErrorMessage,
        type: "error",
        position: "top-right",
      });
    }
  };

  return (
    <>
      <AllariaMasHeader />
      <ModalBody className={`${bodyContainer} m-0 px-10 pt-10 pb-0`}>
        <img src={unifiedIllustration} alt="Allaria+" />

        <div className="flex flex-col items-center justify-center">
          <h1>No encontramos cuentas registradas</h1>
          <p>
            Es necesario crear una cuenta en Allaria+ para unificar tus saldos.
          </p>
        </div>
      </ModalBody>
      <ModalFooter
        className={isMobile ? modalFooterMobile : "flex justify-center items-center"}
      >
        <div className={isMobile ? modalFooterMobile : "flex gap-4"}>
          <Button
            isAllariaMas
            variant="secondary"
            text={!!returnToDepositModal ? "Volver" : "Cerrar"}
            onPress={() => {
              dispatch(closeModal());
              !!returnToDepositModal && dispatch(openDepositModal());
            }}
            className={`${cerrarBtn} ${isMobile ? "w-full mb-2.5" : ""}`}
          />
          <Button
            isAllariaMas
            variant="primary"
            text="Crear cuenta"
            onPress={handleRedirect}
            className={`${unificarBtn} ${isMobile ? "w-full" : ""}`}
          />
        </div>
      </ModalFooter>
    </>
  );
};

export default AllariaMasOnboardingModal;
